import {
  FormGroup,
  Label,
  TextArea
} from '../../section.styles';

const ParagraphUpdateSection = ({ content = {}, metadata = {}, onChange }) => {
  const handleTextChange = (e) => {
    const newText = e.target.value;
    onChange({
      content: { text: newText },
      metadata: {}
    });
  };

  return (
    <FormGroup>
      <Label htmlFor="paragraph-text">Paragraph Text</Label>
      <TextArea
        id="paragraph-text"
        value={content?.text || ''}
        onChange={handleTextChange}
        placeholder="Enter paragraph text..."
        rows={5}
      />
    </FormGroup>
  );
};

export default ParagraphUpdateSection;